<template>
  <div>
    <b-container fluid>
      <b-row align-h="between">
        <h1>システム機能分類</h1>
        <button
          class="btn btn-outline-secondary"
          @click="pageBack"
        >戻る</button>
      </b-row>
      <b-table
        :fields="fields"
        :items="functionClasses"
        bordered
      >
        <template v-slot:cell(delete)="data">
          <b-row align-h="around">
            <button
              @click="deleteFunctionClass(data)"
              class="btn btn-outline-danger"
            >削除</button>
          </b-row>
        </template>
      </b-table>
      <b-row align-h="center">
        <b-col sm=6>
          <b-card title="システム機能分類追加">
            <small>※番号は自動で採番されます</small>
            <b-form-group
              label="システム機能分類"
              label-for="add_function_class"
              label-cols=3
            >
              <b-form-input
                v-model="addfunctionClassName"
                id="add_function_class"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="createFunctionClassName"
            >追加</button>
          </b-card>
        </b-col>
        <b-col sm=6>
          <b-card title="システム機能分類更新">
              <b-form-group
                label="番号"
                label-for="update_function_class"
                label-cols=3
              >
              <b-form-input
                v-model="updateFunctionClass.no"
                id="update_function_class_no"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="名称"
              label-for="update_function_class"
              label-cols=3
            >
              <b-form-input
                v-model="updateFunctionClass.name"
                id="update_function_class_name"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="updateFunctionClassName"
            >更新</button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'FunctionClass',
  data () {
    return {
      functionClasses: [],
      fields: [
        { key: 'no', label: '番号', sortable: true },
        { key: 'function_class', label: 'システム機能分類', sortable: true },
        { key: 'delete', label: '削除/更新' }
      ],
      addfunctionClassName: '',
      showRegister: false,
      updateFunctionClass: {
        no: '',
        name: ''
      }
    }
  },
  async created () {
    this.listFunctionClasses()
  },
  methods: {
    async listFunctionClasses () {
      const funcClasses = await API.graphql(graphqlOperation(`
        query listFunctionClass {
          listFunctionClass{
            no
            function_class
          }
        }
      `))
      this.$log.debug(funcClasses)
      this.functionClasses = [...funcClasses.data.listFunctionClass]
    },
    async deleteFunctionClass (args) {
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation deleteFunctionClass {
            deleteFunctionClass (
              no: ${args.item.no}
            ){
              no
              function_class
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '削除に成功しました', 'info')
        this.listFunctionClasses()
      } catch {
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    async createFunctionClassName () {
      if (this.addfunctionClassName === '') {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation createFunctionClass {
            createFunctionClass (
              function_class: "${this.addfunctionClassName}"
            ){
              no
              function_class
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '追加に成功しました', 'info')
        this.addfunctionClassName = ''
        this.listFunctionClasses()
      } catch {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
      }
    },
    async updateFunctionClassName () {
      if (this.updateFunctionClass.no === '' || this.updateFunctionClass.name === '') {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation updateFunctionClass {
            updateFunctionClass (
              input:{
                no: ${this.updateFunctionClass.no}
                function_class: "${this.updateFunctionClass.name}"
              }
            ){
              no
              function_class
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '更新に成功しました', 'info')
        this.addfunctionClassName = ''
        this.listFunctionClasses()
      } catch {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
      }
    },
    pageBack () {
      this.$router.go(-1)
    }
  }
}
</script>
